import NotificationList from './NotificationList'

export default NotificationList
// eslint-disable-next-line import/export
export * from './NotificationList'
